<template>
  <div id="countdown" class="countdown">
    <div class="countdown-content">
        <div class="row">
          <div class="col">
            <h1>Student Volunteer Applications Open In</h1>
            <div class="row countdown-timing">
              <div class="col timing-group">
                <p class="time">{{ countdownDays }}</p>
                <p class="reference">Days</p>
              </div>
              <div class="col timing-group">
                <p class="time">{{ countdownHours }}</p>
                <p class="reference">Hours</p>
              </div>
              <div class="col timing-group">
                <p class="time">{{ countdownMinutes }}</p>
                <p class="reference"> Minutes</p>
              </div>
              <div class="col timing-group">
                <p class="time">{{ countdownSeconds }}</p>
                <p class="reference"> Seconds</p>
              </div>
            </div>
            <div class="row">
              <ul class="social-list">
                <li>
                  <a href="https://twitter.com/siggraphsv">
                    <i class="social fab fa-2x fa-twitter" alt="Twitter" />
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/SIGGRAPHStudentVolunteers/">
                    <i class="social fab fa-2x fa-facebook" alt="Facebook" />
                  </a>
                </li>
                <li>
                  <a href="#">
                    <i class="social fab fa-2x fa-instagram" alt="Instagram" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'Countdown',
    data () {
      return {
        now: new Date().getTime(),
        launchDate: new Date('Nov 18, 2019 00:00:00')
      }
    },
    computed: {
      countdownDays: function () {
        var distance = this.launchDate - this.now
        return Math.floor(distance / (1000 * 60 * 60 * 24))
      },
      countdownHours: function () {
        var distance = this.launchDate - this.now
        return Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      },
      countdownMinutes: function () {
        var distance = this.launchDate - this.now
        return Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      },
      countdownSeconds: function () {
        var distance = this.launchDate - this.now
        return Math.floor((distance % (1000 * 60)) / 1000)
      }
    },
    created: function () {
      var self = this
      setInterval(function () {
        self.$data.now = new Date().getTime()
      }, 1000)
    }
  }
</script>

<style lang="scss">
  @import '../assets/scss/Countdown.scss';
  @import '~@fortawesome/fontawesome-free/css/all.css';
</style>



// WEBPACK FOOTER //
// src/components/Countdown.vue